import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "./list";
import httpService from "core/infrastructure/http";
import { LtaDto, GetLtaResponse, GetLtaQuery } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "lta";
export const page_config: PageList =
{
    apiUrl: "lta",
    webUrl: "lta",
    menu: "menu:menuLTA",
    title: "menu:titleLTA",
    apiType: "data",
    response: JSON.stringify(keys<GetLtaResponse>()),
    dto: JSON.stringify(keys<LtaDto>()),
    parameters: JSON.stringify(keys<GetLtaQuery>()),
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {
    const initialResponse: any = {};
    const [lastRequestTime, setLastRequestTime] = useState(new Date());
    const [response, setResponse] = useState(initialResponse);
    
    const initialData: LtaDto[] = [];
    const [data, setData] = useState(initialData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        (async function runAsync() {
            let requestTime = new Date();
            setLastRequestTime(requestTime);
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, true, false, keys<LtaDto>());
            setLoading(true);
            setData([]);
            const response = await httpService.apiPost<GetLtaResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,

                query: {
                    FromUtc: applicationState.getRootUtcTime().toISOString(),
                    ToUtc: applicationState.getUntilFor1Day().toISOString()
                },
                senderId: senderId
            })();
            response.requestTime = requestTime;
            setResponse(response);
        })();
    }, [applicationState.selectedDate]);

    useEffect(() => {
        if (lastRequestTime == response.requestTime) {
            if (response.ok) {
                setData(response.data.data);
                setError("");
            } else {
                setError(response.error || t("common:UnknownError"));
            }
            setLoading(false);
        } else { /*we ignore this response, as it was not the last requested*alert(lastRequestTime + " vs " + response.requestTime);*/ }
    }, [response]);

    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <SheetDataPart isLoading={isLoading} data={data} error={error}>
                <List data={data} borders={applicationState.selectedBorders.filter((f) => f.selected)} />
            </SheetDataPart>
        </>
    );
};

export default withTranslation()(Page);
